export enum ExperienceNames {
  HOMEPAGE = 'homepage',
  LANDING_PAGE = 'landing-page',
  SEARCH_PAGE = 'search-page',
  CAPABILITY_PAGE = 'capability-page',
  CAPABILITY_HISTORY_PAGE = 'capability-history-page',
  SLO_PAGE = 'slo-page',
  SLO_GROUP_PAGE = 'slo-group-page',
  SLO_GROUP_CONFIGURATION_PAGE = 'slo-group-configuration-page',
  SLO_GROUP_HISTORY_PAGE = 'slo-group-history-page',
  SLO_GROUP_SYNC_PAGE = 'slo-group-sync-page',
  TEAM_PAGE = 'team-page',
  TEAM_HISTORY_PAGE = 'team-history-page',
  TEAM_PRODUCTS_PAGE = 'team-products-page',
  PRODUCT_PAGE = 'product-page',
  PRODUCT_TEAMS_PAGE = 'product-teams-page',
  PRODUCT_HISTORY_PAGE = 'product-history-page',
}
